export const BookingEmailTemplateSettings = {
  en: {
    'Email templates': 'Email templates',
    'No templates yet': 'No templates yet.',
    kind_personal: 'Personal',
    kind_group: 'Group',
    kind_event: 'Club event',
    'Send emails': 'Send emails',
    active_hint:
      'Sends the letter after a client books online themselves. An admin-created booking never sends one. The on-screen confirmation text below is shown either way.',
    Subject: 'Subject',
    subject_hint:
      'The inbox line. Plain text: any markup is stripped, placeholders are substituted.',
    Body: 'Body',
    body_hint: 'The letter itself. Required while sending is on.',
    'Confirmation text': 'Confirmation text',
    confirmation_text_hint:
      'Shown to the client on screen straight after booking. Independent of the toggle above — it is displayed even when emails are off.',
    'Placeholders hint':
      'Click a placeholder to copy it, then paste it into the subject or the body. An unknown placeholder renders empty.',
    placeholder_client_name: 'Client first name',
    placeholder_service_name: 'Service name',
    placeholder_service_description: 'Service description',
    placeholder_specialist: 'Specialist',
    placeholder_date: 'Date and time',
    placeholder_location: 'Location',
    placeholder_event_name: 'Event name',
    placeholder_wave_name: 'Wave name',
    'Successfully copied': 'Successfully copied',
    'Test email': 'Test email',
    'Send test email': 'Send test email',
    'No service of this kind':
      'There is no bookable service of this kind, so a test letter cannot be built.',
    Service: 'Service',
    Location: 'Location',
    'First name': 'First name',
    Email: 'Email',
  },
  uk: {
    'Email templates': 'Поштові шаблони',
    'No templates yet': 'Шаблонів ще немає.',
    kind_personal: 'Персональне',
    kind_group: 'Групове',
    kind_event: 'Подія клубу',
    'Send emails': 'Надсилати листи',
    active_hint:
      'Лист надсилається, коли клієнт записується онлайн самостійно. Запис, створений адміністратором, листа не надсилає. Текст підтвердження нижче показується в обох випадках.',
    Subject: 'Тема',
    subject_hint:
      'Рядок у поштовій скриньці. Простий текст: розмітка вирізається, плейсхолдери підставляються.',
    Body: 'Основний текст',
    body_hint: 'Сам лист. Обовʼязковий, поки надсилання увімкнене.',
    'Confirmation text': 'Текст підтвердження',
    confirmation_text_hint:
      'Показується клієнту на екрані одразу після запису. Не залежить від перемикача вище — відображається, навіть коли листи вимкнені.',
    'Placeholders hint':
      'Натисніть плейсхолдер, щоб скопіювати його, і вставте в тему або текст. Невідомий плейсхолдер підставиться порожнім.',
    placeholder_client_name: 'Імʼя клієнта',
    placeholder_service_name: 'Назва послуги',
    placeholder_service_description: 'Опис послуги',
    placeholder_specialist: 'Спеціаліст',
    placeholder_date: 'Дата й час',
    placeholder_location: 'Локація',
    placeholder_event_name: 'Назва події',
    placeholder_wave_name: 'Назва хвилі',
    'Successfully copied': 'Успішно скопійовано',
    'Test email': 'Тестовий лист',
    'Send test email': 'Надіслати тестовий лист',
    'No service of this kind':
      'Немає доступної для бронювання послуги цього виду, тому тестовий лист неможливо сформувати.',
    Service: 'Послуга',
    Location: 'Локація',
    'First name': 'Імʼя',
    Email: 'Емейл',
  },
};
